@if (alertMessage) {
  <nrc-alert
    [message]="alertMessage"
    [actionButton]="{ label: 'PAGES.AREA_DETAIL.AREA_ELEMENT.AREA_ELEMENT_ACTION.UNSAVED_CHANGES_ALERT.BUTTONS.ACTION' | translate }"
    [confirmButton]="{ label: 'PAGES.AREA_DETAIL.AREA_ELEMENT.AREA_ELEMENT_ACTION.UNSAVED_CHANGES_ALERT.BUTTONS.CONFIRM' | translate }"
    (confirmEvent)="handleUserChoiceEvent(true)"
    (actionEvent)="handleUserChoiceEvent(false)"
  />
}